import { IGameplayEvent } from '../../../Core/State/IJoinedRoomState';
import { playAudio, stopAudioChannel } from '../../../Utils/AudioUtils';
import { COMMUNITY_CARD_PLACEMENT_AUDIO_CHANNEL } from './PokerPresentationConfig';
import { PokerAudioPresetManager } from './PokerAudioPresetManager';

interface PokerAudioPresentationOptions {
    audioPresetManager: PokerAudioPresetManager;
    isPlaybackAllowed: () => boolean;
    getRoomType: () => string | undefined;
    getCurrentUserId: () => string | undefined;
}

export class PokerAudioPresentation {
    constructor(private readonly options: PokerAudioPresentationOptions) {}

    public reset = () => {
        this.stopCommunityCardPlacementAudio();
    };

    public playGameplayEvent = (event: IGameplayEvent) => {
        if (!this.options.isPlaybackAllowed()) return;

        const sounds = this.options.audioPresetManager.getSelectedPreset().sounds;

        switch (event.kind) {
            case 'playerAction':
                this.playPlayerAction(event);
                break;
            case 'showdownCardsRevealed':
                playAudio(sounds.showdownCards);
                break;
            case 'winnerDeclared':
                playAudio(sounds.showdown);
                break;
            case 'turnStarted':
                if (event.actorUserId === this.options.getCurrentUserId()) {
                    playAudio(sounds.yourTurn);
                }
                break;
            case 'timerWarning':
                if (event.actorUserId === this.options.getCurrentUserId()) {
                    playAudio(sounds.beep);
                }
                break;
            case 'handStarted':
                playAudio(sounds.shuffle);
                break;
        }
    };

    public playCommunityCardPlacement = () => {
        if (!this.options.isPlaybackAllowed()) return;

        const placementSound = this.options.audioPresetManager.getSelectedPreset().communityCardPlacement;
        playAudio(placementSound.file, {
            channel: COMMUNITY_CARD_PLACEMENT_AUDIO_CHANNEL,
            offsetSeconds: placementSound.offsetSeconds,
            durationSeconds: placementSound.durationSeconds
        });
    };

    public stopCommunityCardPlacementAudio = () => {
        stopAudioChannel(COMMUNITY_CARD_PLACEMENT_AUDIO_CHANNEL);
    };

    private playPlayerAction = (event: IGameplayEvent) => {
        const soundFile = this.options.audioPresetManager.getPlayerActionSoundFile(
            event.action,
            this.options.getRoomType()
        );
        if (soundFile) playAudio(soundFile);
    };
}
